module.exports = __webpack_public_path__ + "4f5127d45377cc42d49fc0ad705c9900.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-20.png
// module id = 1601
// module chunks = 0